import styled from 'styled-components';
import { colors } from 'constants/colors';
import { BasicSectionContainer } from 'screens/style';
// import setPhoneNumber from 'assets/icons/setPhoneNumber.svg';
import { styleSizes } from "constants/styleSizes";

export const CompleteContentContainer = styled(BasicSectionContainer)`
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .innerContainer {
    height: 100%;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: ${styleSizes.mobileBreakpoint}) {
          margin:0;
          padding: 0;
    }
  }

  .titleContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${colors.setPhoneNumberBackground};
    width: 100%;
    height: 346px;
    padding: 0 15px;
    @media (max-width: ${styleSizes.tabletBreakpoint}) {
          height: 300px;
    }
    @media (max-width: ${styleSizes.miniBreakpoint}) {
          height: 200px;
    }
    .titleText {
      width: 100%;

      .title {
        font-size: 48px;
        font-weight: bold;
        line-height: 72px;
        text-align: left;
        color: ${colors.white};
        margin-top: -20px;
        position: relative;
        z-index: 20;
        .titleFirstLine {
            max-width: 860px;
            @media (max-width: 1173px) {
              max-width: 500px;
              font-size: 32px;
              line-height: 48px;
            }
            @media (max-width: ${styleSizes.tabletBreakpoint}) {
            margin-bottom: 94px;
            }
            @media (max-width: ${styleSizes.miniBreakpoint}) {
            margin-bottom: 20px;
            font-size: 24px;
            line-height: 32px;
            max-width: 340px;
            }
            @media (max-width: ${styleSizes.mobileBreakpoint}) {
                  max-width: 240px;
            }
        }

        .highLight {
          color: ${colors.checkOutCompleteScreenHighlight};
        }
      }
    }

    .setPhoneNumberImage {
      position: absolute;
        right: 31px;
        bottom: 0;
        width: 457px;
        height: auto;    
        @media (max-width: ${styleSizes.tabletBreakpoint}) {
          height: 270px;
          right: 0;
          width: auto;
        }
        @media (max-width: ${styleSizes.miniBreakpoint}) {
        height: 130px;
        width: auto;
        right: 0;
        bottom: 0;
        }
    }
  }

  .inputRow {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 20px 15px;

    .inputContainerSetPhoneNumber {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 515px;
      min-width: 270px;
      padding: 20px 0 60px 0;
      @media (max-width: ${styleSizes.tabletBreakpoint}) {
        padding: 20px 0 45px 0;
        width: 595px;
        }
    .phoneNumberContainer {
      width: 246px;
      @media (max-width: ${styleSizes.mobileBreakpoint}) {
        width: 100%;
        }
    }

      .description {
        font-size: 16px;
        font-weight: 400;
        max-width: 515px;
        color: ${colors.almostBlack};
        margin: 15px 0 20px 0;
        line-height: 24px;
        text-align: left;
        @media (max-width: ${styleSizes.tabletBreakpoint}) {
          text-align: center;
          max-width: 592px;
          margin: 0 0 20px 0;
        }
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          text-align: left;
        }
        .highLight {
          font-weight: 600;
        }
        
      }
      .submitButtonContainer {
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
        }
      }

    }

    .verifyContainer {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 373px;
      min-width: 373px;
      padding: 30px 0;
      @media (max-width: ${styleSizes.tabletBreakpoint}) {
        padding: 20px 0 20px 0;
        max-width: 600px;
        min-width: auto;
      }

      @media (max-width: ${styleSizes.mobileBreakpoint}) {
        padding: 5px 0 20px 0;
        max-width: 600px;
      }
      .verificationInputBox {
        width: 373px;
        @media (max-width: 420px) {
          width: 100%;

        }
      }
      .verifyButtonContainer {
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
      }
      }

      .verifyTitle {
        font-size: 24px;
        font-weight: bold;
        color: ${colors.almostBlack};
        margin: 15px 0;
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          width: 100%;
        text-align: left;
        }

      }

      .description {
        font-size: 16px;
        font-weight: 400;
        color: ${colors.almostBlack};
        margin: 15px 0;
        line-height: 24px;

        @media (max-width: ${styleSizes.mobileBreakpoint}) {
        text-align: left;
        }
        .highLight {
          color: ${colors.hoverBlue};
          cursor: pointer;
          text-decoration: underline;
        }
      }
      .dontR {
        margin-top: 5px!important;
      }
    }
  }

  /* @media only screen and (max-width: 1200px) {

    .innerContainer {
      flex-direction: column-reverse;
      padding: 0;
      margin: 0;
    }

    .titleContainer {
      height: auto;

      .titleText {
        margin: 20px 0;

        .title {
          text-align: center;
          font-size: 36px;
        }

        .description {
          text-align: center;
        }
      }

      .setPhoneNumberImage {
        position: static;
        width: 100%;
        max-width: 270px;
        min-width: 270px;
        height: 183px;
        margin-top: 20px;
      }
    }
  } */
`;
